import { render, staticRenderFns } from "./ModalDoctorList.vue?vue&type=template&id=1d0f5a33"
import script from "./ModalDoctorList.vue?vue&type=script&lang=js"
export * from "./ModalDoctorList.vue?vue&type=script&lang=js"
import style0 from "./ModalDoctorList.vue?vue&type=style&index=0&id=1d0f5a33&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports